if (!Enum) {
    var Enum = {};
}

Enum.SUBSCRIPTION_AMOUNT = {
    /*BASIC: {
        MONTH: 17.08,
        YEAR: 194.77
    },*/
    BASIC: {
        MONTH: 17.08,
        YEAR: 194.77
    },
    PREMIUM: {
        MONTH: 17.08,
        YEAR: 194.77
    }
};

Object.freeze(Enum.SUBSCRIPTION_AMOUNT);